exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes kRYHalA8pyUIzvBLuECJK{from{transform:translate3d(0, 1rem, 0);visibility:visible;opacity:0}to{transform:translate3d(0, 0, 0);opacity:1}}@keyframes ig5HqFDAJIb6QSVeoz6YX{from{visibility:visible;opacity:0}to{opacity:1}}@keyframes _2wXy1FDYH4I9BkxeYSbJC9{0%{filter:blur(3.125rem)}25%{filter:blur(1.25rem)}100%{filter:blur(0)}}._3x0nTzH5yvOd08BnzhXgcv{font-family:MazdaTypeRegular, sans-serif;font-size:0.875rem;line-height:2.25rem}@media screen and (min-width: 768px){._3x0nTzH5yvOd08BnzhXgcv{font-size:1rem;line-height:2.5rem}}._1cdppsZX6q_-GVSXi6Gqsn{margin-top:3rem}\n", ""]);

// exports
exports.locals = {
	"textBlock": "_3x0nTzH5yvOd08BnzhXgcv",
	"topSpacing": "_1cdppsZX6q_-GVSXi6Gqsn",
	"slideinup": "kRYHalA8pyUIzvBLuECJK",
	"fadeIn": "ig5HqFDAJIb6QSVeoz6YX",
	"blur": "_2wXy1FDYH4I9BkxeYSbJC9"
};